import styled from "styled-components/macro";
import { Modal } from "react-bootstrap";

export const CreatorSubscriptionModalStyles = styled(Modal)`
  .modal-body {
    overflow: auto;
    height: calc(100vh - 104px);

    .plan-details-wrapper {
      padding: 8px;

      .plan-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        border-bottom: 1px solid #ededed;

        .plan-title {
          .plan-header {
            display: flex;
            align-items: center;
            gap: 8px;
          }
        }

        button {
          padding: 0 8px 0 16px;
        }

        h4 {
          color: var(--Neutral-100);
          font-size: 18px;
          font-weight: 500;
          letter-spacing: -0.03px;
          line-height: 22px;
        }

        .duration {
          color: var(--Neutral-80);
          font-size: 14px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: -0.12px;
        }
      }
    }
  }
`;
